
export default function Graph({ points, color, rect, strokeWidth, strokeDasharray, ...props}) {
	const changeBase = (point) => {
		const _x = rect.x + point.x / rect.graph.width * rect.width
		const _y = rect.y - point.y / rect.graph.height * rect.height

		if (point.type === 'bezier') {
			const _bx = rect.x + point.bx / 9 * rect.width
			const _by = rect.y - point.by / 4 * rect.height

			return {
				type : point.type,
				x : _x,
				y : _y,
				bx : _bx,
				by : _by,
			}
		}

		return {
			type : point.type,
			x : _x,
			y : _y
		}
	}

	const createPath = (points) => {
		const real_points = points.map(changeBase)
		let first_point = real_points.shift()
		let path_string = `M ${first_point.x} ${first_point.y}`

		real_points.forEach((p) => {
			if (p.type === 'point') {
				path_string += ` L ${p.x} ${p.y}`
			} else if (p.type === 'bezier') {
				path_string += ` Q ${p.bx} ${p.by}, ${p.x} ${p.y}`
			}
		})

		return path_string
	}

	return (
		<path
			{...props}
			d={createPath(points)}
			fill="transparent"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeDasharray={strokeDasharray}
		/>
	)
}
